export default "__VITE_ASSET__CsOZ_ShP__"